import { useState, useEffect } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { PartnersEditModel } from "../../model/PartnersModel";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  Box,
  LoadingOverlay,
  Grid,
  TextInput,
  Checkbox,
  Button,
  Textarea,
} from "@mantine/core";
import { IconWindow, IconCheck } from "@tabler/icons-react";
import { repositorySign } from "../../_base/_const/_constVar";

const PartnersEditView = ({ id, onClose }: PartnersEditViewProps) => {
  const [entity, setEntity] = useState<PartnersEditModel>({
    orgId: 0,
    vendorId: 0,
    vendorName: null,
    vendorCode: null,
    enabledFlag: null,
    startDateActive: "2024-10-24T03:17:15.681Z",
    endDateActive: "2024-10-24T03:17:15.681Z",
    vendorTypeLookupCode: null,
    employeeId: 0,
    email: null,
    phone: null,
    addr: null,
    creditLimit: 0,
    vatRegistrationNum: null,
  });
  const [visible, { close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);

  const form = useForm<PartnersEditModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    transformValues: (values) => ({
      ...values,
    }),
    validate: {
      vendorCode: (value) => {
        if (!value) {
          return "Vui lòng nhập mã đối tác!";
        }
        return null;
      },
      vendorName: (value) => {
        if (!value) {
          return "Vui lòng nhập tên loại tài liệu!";
        }
        return null;
      },
      addr: (value) => {
        if (!value) {
          return "Vui lòng nhập địa chỉ!";
        }
        return null;
      },
      vatRegistrationNum: (value) => {
        if (!value) {
          return "Vui lòng nhập mã số thuế!";
        }
        return null;
      },
    },
  });
  const handleGetDataPartners = async () => {
    let url = `/api/v1/TblVendor/update?id=${id}`;
    const response = await repositorySign.get<
      MessageResponse<PartnersEditModel>
    >(url);

    if (!response?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }
    if (response?.success) {
      const dataVendor = response?.data;
      if (dataVendor != null) {
        setEntity(dataVendor);
        form.setValues(dataVendor);
        form.resetDirty(dataVendor);
      }
      close();
    } else {
      modals.closeAll();
    }
  };

  const handleEditPartner = async (payload: PartnersEditModel) => {
    open();

    let url = "/api/v1/TblVendor/update";
    const response = await repositorySign.post<MessageResponse<boolean>>(
      url,
      payload
    );

    if (response?.success) {
      onClose((prev: any) => !prev);
      NotificationExtension.Success("Cập nhật thành công!!!");
      modals.closeAll();
    } else {
      NotificationExtension.Fails("Sửa đối tác thất bại !");
    }

    modals.closeAll();
    close();
  };

  useEffect(() => {
    if (id) {
      handleGetDataPartners();
    }
  }, [id]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    }

    setEnable(false);
  }, [form]);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        px="10px"
        w={"500px"}
        onSubmit={form.onSubmit((e: PartnersEditModel) => {
          handleEditPartner(e);
        })}
        style={{
          position: "relative",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid>
          <Grid.Col span={12}>
            <TextInput
              required
              label="Tên đối tác"
              placeholder="Nhập tên đối tác"
              {...form.getInputProps("vendorName")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              required
              label="Mã đối tác"
              placeholder="Nhập mã đối tác"
              {...form.getInputProps("vendorCode")}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <TextInput
              label="Số điện thoại"
              placeholder="Nhập số điện thoại"
              {...form.getInputProps("phone")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label="Email"
              placeholder="Nhập email"
              {...form.getInputProps("email")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              required
              label="Mã số thuế"
              placeholder="Nhập mã số thuế"
              {...form.getInputProps("vatRegistrationNum")}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Textarea
              required
              label="Địa chỉ"
              placeholder="Nhập địa chỉ"
              {...form.getInputProps("addr")}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Checkbox
              label="Sử dụng"
              onClick={(e) => {
                setEntity({
                  ...entity,
                  enabledFlag: entity.enabledFlag === "Y" ? "N" : "Y",
                });
              }}
              checked={entity.enabledFlag == "Y" ? true : false}
              {...form.getInputProps("enabledFlag")}
            ></Checkbox>
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col
            span={12}
            display={"flex"}
            style={{ justifyContent: "flex-end", gap: "40px" }}
          >
            <Button
              type="button"
              color="gray"
              loading={visible}
              onClick={() => {
                modals.closeAll();
              }}
              leftSection={!visible ? <IconWindow size={18} /> : undefined}
            >
              Đóng
            </Button>
            <Button
              type="submit"
              color="blue"
              loading={visible}
              leftSection={!visible ? <IconCheck size={18} /> : undefined}
            >
              Lưu
            </Button>
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};
type PartnersEditViewProps = {
  id: string | number;
  onClose: any;
};
export default PartnersEditView;
